import React from "react";
import PrintText from "./PrintText";
import "./styles.scss";

const WorkInformation = ({ printable_text, legacy_ticket }) => (
  <div className="work-information">
    <PrintText printable_text={printable_text} legacy_ticket={legacy_ticket}/>
    {/* <TicketDetailPhotos /> */}
  </div>
)
export default WorkInformation;
